<div class="box-auth-wrapper common-box-auth-wrapper">
    <mat-card>
        <mat-card-content>
            <img src="../../../../assets/mytyre-logo.png">
            <mat-icon color="primary">sentiment_dissatisfied</mat-icon>
            <mat-label class="mat-display-2">Incomplete Feature</mat-label>
            <p class="mat-caption">Hopefully wait for this feature.</p>
        </mat-card-content>
    </mat-card>
</div>